module.exports = __webpack_public_path__ + "media/images/landing/partner_logos/careem-66d511b8dd44a9c8aa209c322d33214f.png";